import React from "react";
import "./SupportMenu.css";
import { Menu, MenuItem, Divider, ListItemIcon } from '@mui/material';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { useLocation, useNavigate } from 'react-router-dom';
import { getWhatsAppSupportLink } from '../../consts/ContactConfig';

function SupportMenu(props) {
    const { anchorEl, open, onClose } = props;
    const navigate = useNavigate();
    const location = useLocation();

    const handleWhatsAppClick = () => {
        window.open(getWhatsAppSupportLink('Olá! Sou usuário da Gabriela e preciso de ajuda.'), '_blank', 'noopener,noreferrer');
        onClose();
    };

    const handleTutorials = () => {
        navigate('/system/tutorials');
        onClose();
    };

    const handleChangelog = () => {
        navigate('/system/novidades');
        onClose();
    };

    const handleReportProblem = () => {
        // A tela de origem vai junto: é onde o problema aconteceu
        navigate('/support/report-problem', { state: { from: location.pathname } });
        onClose();
    };

    const handleSuggestImprovement = () => {
        navigate('/support/suggest-improvement', { state: { from: location.pathname } });
        onClose();
    };

    const handleEvaluateProduct = () => {
        // Navigate to NPS evaluation page
        navigate('/support/product-evaluation');
        onClose();
    };

    const handleContactUs = () => {
        // Navigate to contact form page
        navigate('/support/contact');
        onClose();
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            PaperProps={{
                elevation: 3,
                sx: {
                    borderRadius: 'var(--border-radius-sm)',
                    minWidth: 220,
                    overflow: 'visible',
                    mt: 1.5,
                    '& .MuiMenuItem-root': {
                        fontSize: '0.875rem',
                        py: 1,
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <MenuItem onClick={handleTutorials}>
                <ListItemIcon>
                    <SchoolOutlinedIcon fontSize="small" />
                </ListItemIcon>
                Tutoriais
            </MenuItem>
            <MenuItem onClick={handleChangelog}>
                <ListItemIcon>
                    <AutoAwesomeOutlinedIcon fontSize="small" />
                </ListItemIcon>
                Novidades
            </MenuItem>
            <MenuItem onClick={handleWhatsAppClick}>
                <ListItemIcon>
                    <WhatsAppIcon fontSize="small" />
                </ListItemIcon>
                Falar no WhatsApp
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleReportProblem}>
                <ListItemIcon>
                    <BugReportOutlinedIcon fontSize="small" />
                </ListItemIcon>
                Reportar Problema
            </MenuItem>
            <MenuItem onClick={handleSuggestImprovement}>
                <ListItemIcon>
                    <LightbulbOutlinedIcon fontSize="small" />
                </ListItemIcon>
                Sugerir Melhoria
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleEvaluateProduct}>
                <ListItemIcon>
                    <StarOutlinedIcon fontSize="small" />
                </ListItemIcon>
                Avaliar Produto (NPS)
            </MenuItem>
            <MenuItem onClick={handleContactUs}>
                <ListItemIcon>
                    <EmailOutlinedIcon fontSize="small" />
                </ListItemIcon>
                Entrar em contato
            </MenuItem>
        </Menu>
    );
}

export default SupportMenu;